





































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Mutation, namespace, Action } from "vuex-class";
import { createNamespacedHelpers } from "vuex";
import { getCodeImg } from "@/api/login";
import store from "@/store/store";
import cookie from "@/util/storage";
import axios from "axios";
import { rsaEncrypt, rsaDecrypt, } from '@/util/util';

// const userModule = namespace("user");
import { UserModule } from "@/store/modules/user";

@Component({
  components: {},
})
export default class PassportLayout extends Vue {
  // @Action("doLogin") Login: any;
  [x: string]: any;
  private loginForm: any = {};
  private showCaptchaCode: boolean = false;
  private loading: boolean = false;
  private checkedcode: boolean = true;
  private ischeck: boolean = true;
  private error: string = "";
  private loginModel: any = {};
  private sectionOneheight: number = 450;
  private rules: any = {
    account: [{ required: true, message: "请输入登录账号", trigger: "blur" }],
    password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
    code: [{ required: false, message: "请输入验证码", trigger: "blur" }],
    orgId: [
      { required: true, message: "请选择院区", trigger: "change" }
    ],
    // warhouseId: [
    //   { required: true, message: "请选择科室", trigger: "change" }
    // ],
  }; // 登陆校验
  private orgListData: any = [];// 院区数据
  private warhouseData: any = [];// 科室数据
  private codeUrl: string = "";
  // @userModule.Action("loginSuccess")
  private loginSuccess: any;

  constructor() {
    super();
  }

  private created() {
    // this.loginForm = this.$form.createForm(this);
  }

  private mounted() {
    this.getCookie();
    this.editAutoHeight();
    this.getCode()
  }

  private editAutoHeight () {
    const height = document.documentElement.clientHeight;
    this.sectionOneheight = height/2 ;
    // document.getElementById("logform").style.margin = h + "px auto";
    // obj.style.margin = h + "px auto";
  }

  private getRedirect(): string {
    if (!this.$route.query.redirect) {
      return "/";
    }
    const redirect: any = this.$route.query.redirect;
    return redirect;
  }
  // 登录前获取验证码
  private async getCode() {
    const result: any = await UserModule.getCaptcha({})
    console.log('getCode-->', result)
    if (result.code === 200) {
      this.showCaptchaCode = Object.keys(result.data).length === 0 ? false : true
      this.loginModel.uudi = result.data.key
      this.codeUrl = result.data.image
    }
  }
  // 登录前获取Cookie
  private getCookie() {
    const toKen: any = cookie.getToken();
    if (toKen) {
      if (toKen.checkedcode) {
        this.checkedcode = true;
        this.loginForm.setFieldsValue({ checkedcode: this.checkedcode });
        this.loginForm.setFieldsValue({ account: toKen.account });
        this.loginForm.setFieldsValue({ password: toKen.password });
      }
    }
  }
  // 获取院区
  searchOrdData(){
    UserModule
      .getloginOrgData({userId:this.loginModel.account}).then((res: any) => {
      if (res.code === 200) {
      this.orgListData = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
  }
  // 院区选择事件
  changeGetData2(value:any){
    this.orgListData.forEach((item:any) => {
      if(item.id === value){
        this.loginModel.parentId = item.parentId;
      }
    });
  this.getWarhouseData();
  }
  // 获取科室
  getWarhouseData(){
    UserModule
      .getloginwarhouse({parentId:this.loginModel.parentId}).then((res: any) => {
      if (res.code === 200) {
      this.warhouseData = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
  }
  // 保存登录账号密码
  private onChange(value: any) {
    this.checkedcode = value.target.checked;
    this.loginModel.setFieldsValue({ checkedcode: this.checkedcode });
  }
  // 提交登录信息
  private handleLoginSubmit(e: any) {
    e.preventDefault();
    // @ts-ignore
    this.$refs.loginForm.validate(async (valid: any) => {
      if (valid) {
        this.loading = true;
        // this.loginForm.setFieldsValue({ checkedcode: this.checkedcode });
        this.loginModel.checkedcode = this.checkedcode;
        // if (this.loginModel.account === "admin") {
        //   this.loginModel.tenantId = "1319448479857704962";
        // } else {
        //   this.loginModel.tenantId = this.loginModel.parentId;
        //   // this.loginModel.tenantId = "";
        // }
        this.loginModel.grantType = "password";
        // const publicKey: any = await UserModule.getPublicKey({account: this.loginModel.account});
        const publicKey: any = await UserModule.getPublicKey({});
        const params = {
          account: this.loginModel.account,
          checkedcode: this.loginModel.checkedcode,
          grantType: this.loginModel.grantType,
          password: rsaEncrypt(this.loginModel.password, publicKey.data),
          code: this.loginModel.code,
          uuid: this.loginModel.uudi,
        }

        const data: any = await UserModule.doLogin(params);
        if (data.code === 200) {
          this.loading = false;
          const redirect: string = this.getRedirect();
          await UserModule.loginSuccess({ loginInfo: data.data });
          if (redirect != null) {
            this.$router.push(redirect);
          } else {
            this.$router.push("/");
          }
        } else {
          this.$message.warning(data.message);
        }
      }
    });
  }
}
